<script>

export default {
    methods: {
        async searchAudits(query) {
            try {
                var p = {};
                for (let k in query) {
                    if (query[k]) {
                        p[k] = query[k];
                    }
                }
                this.$wait.start('loading audits');
                const response = await this.$api.get(`audits?${new URLSearchParams(p).toString()}`);
                return response.data;
            } catch (error) {
                this.$toast.error('There was an error getting audit data');
                return null;
            } finally {
                this.$wait.end('loading audits');
            }
        },
        async auditTypes() {
            try {
                this.$wait.start('loading audit types');
                const response = await this.$api.get(`audits/types`);
                return response.data;
            } catch (error) {
                this.$toast.error('There was an error getting audit types');
                return null;
            } finally {
                this.$wait.end('loading audit types');
            }
        }
    }
};
</script>
